import 'ui-theme/widgets/slideshow/js/slideshow';

(function () {
    var slider = UX.slider;

    var _super_controls = slider.accessibility.keyboardControls;

    slider.accessibility.keyboardControls = function ($slider) {
        const hideNavigationFromReaders = navEl => {
            navEl.attr('aria-hidden', 'true').focus();
            setTimeout(() => {
                navEl.attr('aria-hidden', 'false');
            }, 500);
        };
        // fix autoplay and focus issue while moving between the dots on click
        _super_controls.apply(this, arguments);
        $slider.on('keydown', function (e) {
            slider.$slider = $(this);
            let $focusedElement = $(document.activeElement);
            let type = e.which === 39 ? 'next' : null;
            type = e.which === 37 ? 'prev' : type;
            type = e.which === 13 ? 'enter' : type;

            // use left and right arrow keys to navigate
            if (type === 'next') {
                slider.$slider.trigger('next.owl.carousel');
                hideNavigationFromReaders($slider.find('.owl-next'));
            } else if (type === 'prev') {
                slider.$slider.trigger('prev.owl.carousel');
                hideNavigationFromReaders($slider.find('.owl-prev'));
            } else if (type === 'enter') {
                // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction

                if ($focusedElement.hasClass('owl-next')) {
                    e.preventDefault();
                    slider.$slider.trigger('next.owl.carousel');
                } else if ($focusedElement.hasClass('owl-prev')) {
                    e.preventDefault();
                    slider.$slider.trigger('prev.owl.carousel');
                } else if (
                    $focusedElement.hasClass('owl-dot') ||
                    $focusedElement.hasClass('owl-play') ||
                    $focusedElement.hasClass('owl-pause')
                ) {
                    $focusedElement.trigger('click');
                }
            }
        });

        $slider.on('translate.owl.carousel', function (event) {
            $slider.find('.owl-stage-outer').attr({
                'aria-busy': true,
            });
        });

        $slider.on('translate.owl.carousel', function (event) {
            $slider.find('.owl-stage-outer').attr({
                'aria-busy': false,
            });

            slider.accessibility.slider($slider);
        });
    };
})();
